import { defineComponent as a, openBlock as r, createElementBlock as c, createElementVNode as e, toDisplayString as i, createStaticVNode as n } from "vue";
import { _ as p } from "./chunks/_plugin-vue_export-helper.dad06003.js";
import './assets/AdvertisingPopover.css';const d = { class: "frisbuy-advertising-popover" }, _ = { class: "frisbuy-advertising-popover__note" }, v = { class: "frisbuy-advertising-popover__wrapper" }, l = { class: "frisbuy-advertising-popover__advertiser" }, C = { class: "frisbuy-advertising-popover__inn" }, f = /* @__PURE__ */ n('<svg class="frisbuy-advertising-popover__icon" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" data-v-4b0eccf1><g clip-path="url(#clip0_3477_72958)" data-v-4b0eccf1><path d="M9 9.75C9 10.1478 8.84196 10.5294 8.56066 10.8107C8.27936 11.092 7.89782 11.25 7.5 11.25H2.25C1.85218 11.25 1.47064 11.092 1.18934 10.8107C0.908035 10.5294 0.75 10.1478 0.75 9.75V4.5C0.75 4.10218 0.908035 3.72064 1.18934 3.43934C1.47064 3.15804 1.85218 3 2.25 3V3.75C2.05109 3.75 1.86032 3.82902 1.71967 3.96967C1.57902 4.11032 1.5 4.30109 1.5 4.5V9.75C1.5 9.94891 1.57902 10.1397 1.71967 10.2803C1.86032 10.421 2.05109 10.5 2.25 10.5H7.5C7.69891 10.5 7.88968 10.421 8.03033 10.2803C8.17098 10.1397 8.25 9.94891 8.25 9.75H9Z" fill="#409EFF" data-v-4b0eccf1></path><path d="M4.5 1.5C4.30109 1.5 4.11032 1.57902 3.96967 1.71967C3.82902 1.86032 3.75 2.05109 3.75 2.25V7.5C3.75 7.69891 3.82902 7.88968 3.96967 8.03033C4.11032 8.17098 4.30109 8.25 4.5 8.25H9.75C9.94891 8.25 10.1397 8.17098 10.2803 8.03033C10.421 7.88968 10.5 7.69891 10.5 7.5V2.25C10.5 2.05109 10.421 1.86032 10.2803 1.71967C10.1397 1.57902 9.94891 1.5 9.75 1.5H4.5ZM4.5 0.75H9.75C10.1478 0.75 10.5294 0.908035 10.8107 1.18934C11.092 1.47064 11.25 1.85218 11.25 2.25V7.5C11.25 7.89782 11.092 8.27936 10.8107 8.56066C10.5294 8.84196 10.1478 9 9.75 9H4.5C4.10218 9 3.72064 8.84196 3.43934 8.56066C3.15804 8.27936 3 7.89782 3 7.5V2.25C3 1.85218 3.15804 1.47064 3.43934 1.18934C3.72064 0.908035 4.10218 0.75 4.5 0.75Z" fill="#409EFF" data-v-4b0eccf1></path></g><defs data-v-4b0eccf1><clipPath id="clip0_3477_72958" data-v-4b0eccf1><rect width="12" height="12" fill="white" data-v-4b0eccf1></rect></clipPath></defs></svg>', 1), g = /* @__PURE__ */ a({
  __name: "AdvertisingPopover",
  props: {
    erid: {},
    advertiser: {},
    inn: {},
    note: {}
  },
  setup(s) {
    const t = s;
    function o() {
      navigator.clipboard.writeText(t.erid);
    }
    return (h, b) => (r(), c("div", d, [
      e("span", _, i(t.note), 1),
      e("div", v, [
        e("span", l, i(t.advertiser) + ":", 1),
        e("span", C, i(t.inn), 1),
        e("span", {
          class: "frisbuy-advertising-popover__erid",
          onClick: o
        }, [
          e("span", null, i(t.erid), 1),
          f
        ])
      ])
    ]));
  }
});
const m = /* @__PURE__ */ p(g, [["__scopeId", "data-v-4b0eccf1"]]);
export {
  m as default
};
